/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SubscriptionsRouteImport } from './routes/subscriptions'
import { Route as StorageRouteImport } from './routes/storage'
import { Route as SitesRouteImport } from './routes/sites'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SectorNewsRouteImport } from './routes/sector-news'
import { Route as ReferralsRouteImport } from './routes/referrals'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as PeopleRouteImport } from './routes/people'
import { Route as OrganisationsRouteImport } from './routes/organisations'
import { Route as LeadResearchRouteImport } from './routes/lead-research'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as InboundRouteImport } from './routes/inbound'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PeoplePersonIdRouteImport } from './routes/people_.$personId'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRoute = StorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesRoute = SitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SectorNewsRoute = SectorNewsRouteImport.update({
  id: '/sector-news',
  path: '/sector-news',
  getParentRoute: () => rootRouteImport,
} as any)
const ReferralsRoute = ReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleRoute = PeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsRoute = OrganisationsRouteImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadResearchRoute = LeadResearchRouteImport.update({
  id: '/lead-research',
  path: '/lead-research',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const InboundRoute = InboundRouteImport.update({
  id: '/inbound',
  path: '/inbound',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeoplePersonIdRoute = PeoplePersonIdRouteImport.update({
  id: '/people_/$personId',
  path: '/people/$personId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/inbound': typeof InboundRoute
  '/invoices': typeof InvoicesRoute
  '/lead-research': typeof LeadResearchRoute
  '/organisations': typeof OrganisationsRoute
  '/people': typeof PeopleRoute
  '/pipeline': typeof PipelineRoute
  '/referrals': typeof ReferralsRoute
  '/sector-news': typeof SectorNewsRoute
  '/settings': typeof SettingsRoute
  '/sites': typeof SitesRoute
  '/storage': typeof StorageRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/users': typeof UsersRoute
  '/people/$personId': typeof PeoplePersonIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/inbound': typeof InboundRoute
  '/invoices': typeof InvoicesRoute
  '/lead-research': typeof LeadResearchRoute
  '/organisations': typeof OrganisationsRoute
  '/people': typeof PeopleRoute
  '/pipeline': typeof PipelineRoute
  '/referrals': typeof ReferralsRoute
  '/sector-news': typeof SectorNewsRoute
  '/settings': typeof SettingsRoute
  '/sites': typeof SitesRoute
  '/storage': typeof StorageRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/users': typeof UsersRoute
  '/people/$personId': typeof PeoplePersonIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/customers': typeof CustomersRoute
  '/inbound': typeof InboundRoute
  '/invoices': typeof InvoicesRoute
  '/lead-research': typeof LeadResearchRoute
  '/organisations': typeof OrganisationsRoute
  '/people': typeof PeopleRoute
  '/pipeline': typeof PipelineRoute
  '/referrals': typeof ReferralsRoute
  '/sector-news': typeof SectorNewsRoute
  '/settings': typeof SettingsRoute
  '/sites': typeof SitesRoute
  '/storage': typeof StorageRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/users': typeof UsersRoute
  '/people_/$personId': typeof PeoplePersonIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/customers'
    | '/inbound'
    | '/invoices'
    | '/lead-research'
    | '/organisations'
    | '/people'
    | '/pipeline'
    | '/referrals'
    | '/sector-news'
    | '/settings'
    | '/sites'
    | '/storage'
    | '/subscriptions'
    | '/users'
    | '/people/$personId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/customers'
    | '/inbound'
    | '/invoices'
    | '/lead-research'
    | '/organisations'
    | '/people'
    | '/pipeline'
    | '/referrals'
    | '/sector-news'
    | '/settings'
    | '/sites'
    | '/storage'
    | '/subscriptions'
    | '/users'
    | '/people/$personId'
  id:
    | '__root__'
    | '/'
    | '/customers'
    | '/inbound'
    | '/invoices'
    | '/lead-research'
    | '/organisations'
    | '/people'
    | '/pipeline'
    | '/referrals'
    | '/sector-news'
    | '/settings'
    | '/sites'
    | '/storage'
    | '/subscriptions'
    | '/users'
    | '/people_/$personId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomersRoute: typeof CustomersRoute
  InboundRoute: typeof InboundRoute
  InvoicesRoute: typeof InvoicesRoute
  LeadResearchRoute: typeof LeadResearchRoute
  OrganisationsRoute: typeof OrganisationsRoute
  PeopleRoute: typeof PeopleRoute
  PipelineRoute: typeof PipelineRoute
  ReferralsRoute: typeof ReferralsRoute
  SectorNewsRoute: typeof SectorNewsRoute
  SettingsRoute: typeof SettingsRoute
  SitesRoute: typeof SitesRoute
  StorageRoute: typeof StorageRoute
  SubscriptionsRoute: typeof SubscriptionsRoute
  UsersRoute: typeof UsersRoute
  PeoplePersonIdRoute: typeof PeoplePersonIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage': {
      id: '/storage'
      path: '/storage'
      fullPath: '/storage'
      preLoaderRoute: typeof StorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sector-news': {
      id: '/sector-news'
      path: '/sector-news'
      fullPath: '/sector-news'
      preLoaderRoute: typeof SectorNewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/referrals': {
      id: '/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ReferralsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people': {
      id: '/people'
      path: '/people'
      fullPath: '/people'
      preLoaderRoute: typeof PeopleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations': {
      id: '/organisations'
      path: '/organisations'
      fullPath: '/organisations'
      preLoaderRoute: typeof OrganisationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lead-research': {
      id: '/lead-research'
      path: '/lead-research'
      fullPath: '/lead-research'
      preLoaderRoute: typeof LeadResearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbound': {
      id: '/inbound'
      path: '/inbound'
      fullPath: '/inbound'
      preLoaderRoute: typeof InboundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people_/$personId': {
      id: '/people_/$personId'
      path: '/people/$personId'
      fullPath: '/people/$personId'
      preLoaderRoute: typeof PeoplePersonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomersRoute: CustomersRoute,
  InboundRoute: InboundRoute,
  InvoicesRoute: InvoicesRoute,
  LeadResearchRoute: LeadResearchRoute,
  OrganisationsRoute: OrganisationsRoute,
  PeopleRoute: PeopleRoute,
  PipelineRoute: PipelineRoute,
  ReferralsRoute: ReferralsRoute,
  SectorNewsRoute: SectorNewsRoute,
  SettingsRoute: SettingsRoute,
  SitesRoute: SitesRoute,
  StorageRoute: StorageRoute,
  SubscriptionsRoute: SubscriptionsRoute,
  UsersRoute: UsersRoute,
  PeoplePersonIdRoute: PeoplePersonIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
